// UI Preview Mode flag. Priority:
//   1. Explicit VITE_UI_PREVIEW_MODE === 'true'  → preview (any mode, incl. production build).
//   2. Explicit VITE_UI_PREVIEW_MODE === 'false' → normal (forces real Supabase even in dev).
//   3. Otherwise, LOCAL DEV ONLY: if no Supabase URL is configured, fall back to preview so a
//      bare `pnpm dev` opens with mock data instead of crashing on missing env.
// A production build (import.meta.env.DEV === false) NEVER auto-activates preview — it stays in
// normal mode and still requires real Supabase env vars unless the flag is explicitly 'true'.
export function isPreviewMode(): boolean {
  const explicit = import.meta.env.VITE_UI_PREVIEW_MODE;
  if (explicit === 'true') return true;
  if (explicit === 'false') return false;
  return import.meta.env.DEV === true && !import.meta.env.VITE_SUPABASE_URL;
}

export interface PreviewCompany {
  readonly id: string;
  readonly name: string;
}

export const PREVIEW_COMPANIES: readonly PreviewCompany[] = [
  { id: 'c1000000-0000-4000-8000-000000000001', name: 'შპს ალფა ტრეიდი' },
  { id: 'c2000000-0000-4000-8000-000000000002', name: 'შპს ბეტა დისტრიბუცია' },
];

let activeCompanyId: string = PREVIEW_COMPANIES[0]!.id;

export function getActivePreviewCompany(): string {
  return activeCompanyId;
}

export function setActivePreviewCompany(id: string): void {
  if (PREVIEW_COMPANIES.some((c) => c.id === id)) {
    activeCompanyId = id;
  }
}

// Mock authenticated identity (matches backend role codes; carries company-scope roles so
// every implemented screen is reachable in the preview).
export const PREVIEW_AUTH_USER_ID = 'a0000000-0000-4000-8000-0000000000aa';
export const PREVIEW_ACTOR_ID = 'ac000000-0000-4000-8000-0000000000ac';
export const PREVIEW_ROLES = ['administrator', 'finance_manager', 'management'] as const;
